export enum AppRoute {
  Home = '/',
  Results = '/verificar',
  About = '/sobre',
  Report = '/denunciar',
  ReportSuccess = '/denunciado'
}
